<template>
  <div class="d-flex flex-column preview-img">
    <div class="image-preview__wrapper mb-6" v-if="imgPath">
      <img class="image-preview" :src="imgPath" />
    </div>

    <div>
      <bim-button
        @click="buttonClick"
        small
        class="mb-6"
        noshadow
      >
        {{ name }}
        <slot></slot>
      </bim-button>

      <input
        :ref="id"
        type="file"
        class="d-none"
        @change="uploadFile"
        accept=".png, .jpg, .jpeg"
        formKey="imgPath"
        :formModel="_self"
      />
    </div>
  </div>
</template>

<script>
import validationMixin from '../validation.mixin'
import bimButton from '@/components/form/bimButton/bimButton'
export default {
  name: 'FieldImgUpload',
  mixins: [validationMixin],
  props: {
    name: String,
    imgPath: String,
    id: {
      type: String,
      required: true
    },
  },
  components: {
    bimButton,
  },
  methods: {
    uploadFile (event) {
      this.$emit('upload', event)
      this.validate()
    },
    buttonClick () {
      this.$refs[this.id].click()
    }
  },
}
</script>

<style scoped lang="scss">
.image-preview__wrapper {
  .image-preview {
    padding: 10px;
    border-radius: 5px;
    object-fit: contain;
    max-height: 500px;
    max-width: 500px;
    transition: box-shadow .2s;

    &:hover {
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
